import { routes } from '../admin/settings/routes';
import Onboarding from '../Components/Onboarding/Onboarding';
import { Router, Route, Link } from './index';



const CustomRouter = () => (
  <Router routes={routes} defaultRoute={routes?.onboarding?.path}>
    <Route path={routes.onboarding.path}><Onboarding /></Route>
  </Router>
);

export default CustomRouter;